<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <h4 class="about-title">{{ ls_ContactUs }}</h4>
        <b-card class="about-cart">
          <div class="about-content">
            <h5 class="title-label">
              {{ ls_Address }}
            </h5>
            <p class="title-content" v-html="address"></p>
            <h5 class="title-label">{{ ls_Phone }}</h5>
            <p class="title-content" v-html="phone"></p>
            <h5 class="title-label">E-mail</h5>
            <p class="title-content" v-html="email"></p>
            <!-- <h5 class="title-label">{{ ls_Secretary }}</h5>
            <p class="title-content" v-html="pressSecretary !== undefined ? pressSecretary.replace(/\n/g, '<br>') : ''"></p> -->
          </div>
          <div class="projects-accordion" role="tablist">
            <b-card
              no-body
              class="accordion-card">
              <!-- <b-card-header
                header-tag="header"
                role="tab"
                class="accordion-header">
                <h4
                  class="accordion-title"
                  v-b-toggle="'accordion'"
                  variant="info">
                  {{ ls_PhoneDirectory }} <i class="far fa-chevron-down accordion-down-icon"></i>
                </h4>
              </b-card-header>
              <b-collapse
                :id="'accordion'"
                visible
                accordion="my-accordion"
                role="tabpanel"
                class="accordion-content">
                <b-card-body class="accordion-body">
                  <div class="card-text">
                    
                  </div>
                </b-card-body>
              </b-collapse> -->
              <div class="map" v-html="mapEmbed"></div>
            </b-card>
          </div>
        </b-card>
      </b-col>
      <b-col cols="4">
        <div class="sidebar-banner">
          <b-link :href="host + '/ads/show/17.html'" target="_blank" class="sidebar-banner-link">
            <img :src="host + '/ads/show/17.png'" alt="xxx">
          </b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";

export default {
  data() {
    return {
      structrue: ""
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    mapEmbed() {
      return this.$store.state.siteSettings.mapEmbed;
    },
    pressSecretary() {
      return this.$store.state.siteSettings.pressSecretary;
    },
    phone() {
      return this.$store.state.siteSettings.phone;
    },
    address() {
      return this.$store.state.siteSettings.address;
    },
    email() {
      return this.$store.state.siteSettings.email;
    },
    menuList() {
      let list = [];
      if (this.$store.state.navigationList.length > 0) {
        list = this.$store.state.navigationList.filter(
          n => n.url === "/about/us"
        )[0].childList;
      }

      return list;
    },

    currentMenu() {
      return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
    },

    ls_Address() {
      return this.$store.state.languagePack.ls_Address;
    },

    ls_Phone() {
      return this.$store.state.languagePack.ls_Phone;
    },

    ls_Secretary() {
      return this.$store.state.languagePack.ls_Secretary;
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    ls_ContactUs() {
      return this.$store.state.languagePack.ls_ContactUs;
    },

    ls_PhoneDirectory() {
      return this.$store.state.languagePack.ls_PhoneDirectory;
    },

    leaderMenuList() {
      let leaderMenus = [];
      if (this.menuList.length > 0) {
        this.menuList.forEach(function(menu) {
          leaderMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
      }
      return leaderMenus;
    }
  },

  methods: {
    replaceImage(content) {
      return content.replace(
        "/uploads/images/",
        this.host + "/uploads/images/"
      ).replace(". png", ".png").replace(". jpg", ".jpg").replace(". jpeg", ".jpeg");
    }
  },

  metaInfo() {
    return {
      title: this.ls_ContactUs
    };
  },

  components: {
    "sidebar-nav": SidebarNavigation
  }
};
</script>

<style lang="scss" scoped>
.about-cart {
  border-radius: 0;

  .about-content {
    font-size: 16px;
    color: #333333;
    font-family: Roboto;

    img {
      width: 100% !important;
    }
  }
}
.projects-accordion {
  .accordion-card {
    border-radius: 0;
    border: 0;
    background-color: transparent;
    margin-bottom: 0 !important;

    .accordion-header {
      padding: 0.25rem 1rem;
      background-color: #ffffff;
      border: 1px solid #ededed;
      border-left: 2px solid #959596;
      border-radius: 0;

      .accordion-title.collapsed .accordion-down-icon {
        transform: rotate(0deg);
      }

      .accordion-title {
        margin: 0.25rem 0 0.5rem 0;
        color: #1f93ae;
        font-size: 1.25rem;

        .accordion-down-icon {
          transform: rotate(-180deg);
          padding-top: 0.375rem;
          font-size: 1rem;
          float: right;
          color: #959596;
          transition: all 0.7s;
        }
      }
    }

    .accordion-content {
      border: 1px solid #ededed;
      background-color: #ffffff;
      margin-top: 0.5rem;

      .accordion-body {
        color: #7a7a7a;

        .img-shape {
          float: left;
          padding-right: 1rem;
        }
      }
    }
  }
}
.title-label {
  font-size: 18px;
  font-weight: 600;
}
.title-content {
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif, Roboto;
  color: #777777;
  text-indent: 0;
  margin-bottom: 18px;
}
/* RTL */

.rtl-layout {
  .about-content * {
    direction: rtl;
    text-align: right;
  }
}
</style>

<style>
.about-cart .about-content img {
  max-width: 100% !important;
}
.map {
  margin-top: 2rem;
}
.map iframe {
  width: 100% !important;
}
</style>
